// extracted by mini-css-extract-plugin
export default {"section":"Secure_section__ZWr6L","row":"Secure_row__c9jc-","imgcol":"Secure_imgcol__R5GFL","img":"Secure_img__CBt6M","free":"Secure_free__A52Dv","desc":"Secure_desc__2f686"};